export const language: any = {
  selected_ingredients: 'Nguyên liệu đã chọn',
  recommend: 'Món ăn đề xuất',
  title_detail: 'Công thức đề xuất',
  share: 'Chia sẻ',
  ingredients: {
    title: `<span class="tracking-tighter whitespace-nowrap">Nguyên liệu</span> <span class="tracking-tighter whitespace-nowrap">(1 người)</span>`,
    add_all: 'Thêm tất cả nguyên liệu',
    view_more: 'Xem thêm {number} nguyên liệu',
    view_less: 'Gập lại',
    delete_all: 'Xoá tất cả nguyên liệu',
  },
  how_to_cook: 'Cách nấu',
  video: {
    title: 'Video công thức',
  },
  msg: {
    msg_1: "Bạn có muốn xoá nguyên liệu tương ứng không?",
    msg_2: "Bạn có muốn xoá tất cả nguyên liệu không?",
    msg_3: "Bạn có muốn thêm nguyên liệu tương ứng không?",
    msg_4: "Bạn có muốn thêm tất cả nguyên liệu còn thiếu không?",
    msg_5: "Bạn có muốn thêm nguyên liệu này vào giỏ hàng không?",
    msg_6: "Nguyên liệu này đã có trong giỏ hàng",
    confirm: "Có",
    cancel: "Không",
  },
  recipe_exist_in_cart:"Nguyên liệu tương ứng đã có ở giỏ hàng.",
  recipe_want_add_to_cart:"Bạn có muốn thêm nguyên liệu đã chọn vào giỏ hàng không ?",
  recipe_exist_in_cart_should_exclued:"bị loại trừ do đã có ở giỏ hàng hiện tại.",
  calories_description: "Món ăn này dự kiến cung cấp {calories} dựa theo công thức bên dưới. Hãy cân nhắc để có lựa chọn phù hợp cho sức khỏe của bạn nhé!",
  title_share_sns: "Chia sẻ công thức này trên",
  copy: "Sao chép",
  recipe_add_cart_success: "Đã thêm vào giỏ hàng. Bạn có muốn di chuyển đến màn hình giỏ hàng không? ",
  recipe_close: "Hủy",
  recipe_move: "Di chuyển",
  recipe_add_ingredient_success: "Đã thêm nguyên liệu của tôi, bạn có muốn di chuyển đến màn hình nguyên liệu của tôi không?",
  copied: "Đã sao chép",
  text_share_sns: `{recipe_name} công thức này thế nào?\nHãy thử xem ở Hey!cooker nhé!`,
  search:{
    title: "Tìm kiếm công thức",
    searching: "Hey Cooker đang tìm kiếm công thức món ăn phù<br/> hợp với từ khóa của bạn, vui lòng chờ một chút nhé!",
    not_found: "Hmm, đầu bếp AI không thấy món ăn nào phù hợp<br/> với từ khóa của bạn, hãy thử nhập tên món ăn khác vào nhé.",
    placeholder: "Nhập tên công thức bạn muốn tìm kiếm...",
    msg_default_recipe: "Bạn chưa có công thức món ăn nào",
  },
  noData: "Không tìm thấy kết quả",
  searching: "Đang tìm kiếm..."
}
